module.exports = __webpack_public_path__ + "static/img/msg_image.05b1d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/msg_image.jpg
// module id = zDd/
// module chunks = 202